import React, { useState, useRef, useCallback,useEffect } from "react";
import Header from "../components/Header";
import { motion, AnimatePresence } from "framer-motion";
import AdminSideBar from "../components/AdminSideBar";
import ReportDropdown2 from "../components/ReportDropdown2";
import Footer from "../components/Footer";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc, updateDoc, doc, getDocs, writeBatch, // Add this import
  arrayUnion  } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL,  uploadBytesResumable // Add this import
} from "firebase/storage";
import emailjs from '@emailjs/browser';
import { uploadToCloudinary } from "../../utils/CloudinaryUpload"; // Adjust path as needed
const firebaseConfig = {
  apiKey: "AIzaSyDy9FwTdqL1A0BhoU6OWHiyCQ_XGCCma-s",
  authDomain: "farmnet-a74d9.firebaseapp.com",
  projectId: "farmnet-a74d9",
  storageBucket: "farmnet-a74d9.firebasestorage.app",
  messagingSenderId: "393546903507",
  appId: "1:393546903507:web:a454500b9a4ab7bcb20926",
  measurementId: "G-B7VBQ9H17Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

const emailjsConfig = {
  serviceId: "service_8o7iueh", // From EmailJS dashboard
  templateId: "template_wrk6yjs", // From EmailJS dashboard
  userId: "CwUBiyAh0zdC3QwU5" // From EmailJS dashboard
};

const Dropdown1 = ({ label, items, type, isProjectDropdown, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedCircles, setSelectedCircles] = useState({});
  
  const contentRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [thumbHeight, setThumbHeight] = useState(40);
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [startScrollTop, setStartScrollTop] = useState(0);
  const thumbRef = useRef(null);

  const toggleCircle = (item) => {
      setSelectedCircles((prev) => ({
          ...prev,
          [item]: !prev[item],
      }));
  };

  const handleSelect = (item) => {
      setSelectedItems(prev => {
          if (prev.includes(item)) {
              return prev.filter(i => i !== item);
          } else {
              return [...prev, item];
          }
      });
      
      if (typeof onChange === "function") {
          onChange(type, item);
      }
  };

  useEffect(() => {
      const content = contentRef.current;
      if (!content) return;

      const updateThumbHeight = () => {
          const { scrollHeight, clientHeight } = content;
          const visibleRatio = clientHeight / scrollHeight;
          setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
      };

      updateThumbHeight();
      window.addEventListener("resize", updateThumbHeight);
      return () => window.removeEventListener("resize", updateThumbHeight);
  }, [isOpen, items]);

  const handleScroll = () => {
      const content = contentRef.current;
      if (!content) return;

      const { scrollTop, scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      const scrollRatio = scrollTop / maxScrollTop;
      const trackHeight = content.clientHeight - thumbHeight;
      setScrollTop(scrollRatio * trackHeight);
  };

  const handleThumbMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();

      setIsDragging(true);
      setStartY(e.clientY);
      setStartScrollTop(contentRef.current.scrollTop);

      document.addEventListener("mousemove", handleThumbMouseMove);
      document.addEventListener("mouseup", handleThumbMouseUp);
      document.body.style.cursor = "grabbing";
  };

  const handleThumbMouseMove = (e) => {
      if (!isDragging) return;

      const deltaY = e.clientY - startY;
      const content = contentRef.current;
      const { scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      const trackHeight = clientHeight - thumbHeight;

      const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
      const newScrollTop = Math.min(
          Math.max(0, startScrollTop + scrollDelta),
          maxScrollTop
      );

      content.scrollTop = newScrollTop;
  };

  const handleThumbMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener("mousemove", handleThumbMouseMove);
      document.removeEventListener("mouseup", handleThumbMouseUp);
      document.body.style.cursor = "";
  };

  const handleTrackClick = (e) => {
      const content = contentRef.current;
      if (!content || e.target === thumbRef.current) return;

      const track = e.currentTarget;
      const trackRect = track.getBoundingClientRect();
      const clickPosition = e.clientY - trackRect.top;
      const thumbCenter = thumbHeight / 2;
      const scrollRatio =
          (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

      const { scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      content.scrollTop = scrollRatio * maxScrollTop;
  };

  const handleButtonScroll = (direction) => {
      if (contentRef.current) {
          contentRef.current.scrollBy({
              top: direction === 'up' ? -50 : 50,
              behavior: 'smooth'
          });
      }
  };

  return (
      <div className="flex flex-col w-full relative">
          <span className="text-[6px] md:text-[14px] md:mb-3 font-extrabold">
              {isProjectDropdown ? "" : label || "LANGUAGE"}
          </span>
          <div className="flex relative z-20 w-fit">
              <button
                  onClick={() => {
                      if (isProjectDropdown && selectedItems.includes("Funding")) {
                          window.location.href = "/funding";
                      } else {
                          setIsOpen(prev => !prev);
                      }
                  }}
                  className={`xl:w-[160px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[40px] bg-[#2E453D] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
              >
                  <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
                      {selectedItems.length > 0 ? selectedItems[0] : "-"}
                  </span>
              </button>

              <div
                  className="w-[15px] h-[15px] md:h-[40px] md:w-[40px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                  onClick={() => setIsOpen(prev => !prev)}
              >
                  <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                      alt="expand"
                      className="w-2 h-[10px] md:w-6 md:h-[24px]"
                  />
              </div>
          </div>

          <AnimatePresence>
              {isOpen && (
                  <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute top-full mt-1 left-0 z-[100] md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
                  >
                      <div className="w-full flex justify-end py-1">
                          <button 
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonScroll('up');
                              }}
                              className="p-1"
                          >
                              <img 
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png" 
                                  alt="Scroll up" 
                                  className="w-3 h-3"
                              />
                          </button>
                      </div>

                      <div className="custom-scroll-area">
                          <ul
                              className="custom-scroll-content"
                              ref={contentRef}
                              onScroll={handleScroll}
                          >
                          <li className="flex items-center justify-between px-2 py-1 mb-2">
                              <span className="text-[6px] md:text-[20px] font-semibold">
                                  {isProjectDropdown ? "Purpose" : label || "Language"}
                              </span>
                              <img
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750034880/Export_1_vurzim.png"
                                  alt="icon"
                                  className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      setIsOpen(false);
                                  }}
                              />
                          </li>
                              
                              {items && items.map((item, index) => (
                                  <li
                                      key={index}
                                      className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                                          selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                                      }`}
                                      onClick={() => handleSelect(item)}
                                  >
                                      <span className="text-black text-[4px] md:text-[18px]">
                                          {item}
                                      </span>
                                      <div
                                          className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${
                                              selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                                          }`}
                                      ></div>
                                  </li>
                              ))}
                          </ul>
                          <div className="custom-scroll-track" onClick={handleTrackClick}>
                              <div
                                  ref={thumbRef}
                                  className="custom-scroll-thumb"
                                  style={{
                                      height: `${thumbHeight}px`,
                                      top: `${scrollTop}px`,
                                      cursor: isDragging ? "grabbing" : "grab",
                                  }}
                                  onMouseDown={handleThumbMouseDown}
                              ></div>
                          </div>
                      </div>

                      <div className="w-full flex justify-end py-1">
                          <button 
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonScroll('down');
                              }}
                              className="p-1"
                          >
                              <img 
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png" 
                                  alt="Scroll down" 
                                  className="w-3 h-3"
                              />
                          </button>
                      </div>
                  </motion.div>
              )}
          </AnimatePresence>
          <p className="md:text-[10px] text-[4px] font-normal mt-1 text-black">
          Select type of communication
          </p>

          <style jsx>{`
              .custom-scroll-area {
                  position: relative;
                  max-height: 200px;
                  display: flex;
                  overflow: hidden;
              }

              .custom-scroll-content {
                  flex: 1;
                  overflow-y: scroll;
                  scrollbar-width: none;
                  -ms-overflow-style: none;
                  padding-right: 4px;
              }

              .custom-scroll-content::-webkit-scrollbar {
                  display: none;
              }

              .custom-scroll-track {
                  width: 14px;
                  background: #e7ebeb;
                  border-radius: 3px;
                  position: relative;
                  margin-left: 4px;
                  cursor: pointer;
              }

              .custom-scroll-thumb {
                  width: 100%;
                  background: #979797;
                  border-radius: 3px;
                  position: absolute;
                  right: 0;
                  transition: background 0.2s;
              }

              .custom-scroll-thumb:hover {
                  background: #444;
              }

              @media (max-width: 768px) {
                  .custom-scroll-track {
                      width: 4px;
                      margin-left: 2px;
                  }
                  .custom-scroll-area {
                      position: relative;
                      max-height: 150px;
                      display: flex;
                      overflow: hidden;
                      width: 100%;
                  }
              }
          `}</style>
      </div>
  );
};
const Dropdown = ({ label, items, type, isProjectDropdown, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedCircles, setSelectedCircles] = useState({});
  
  const contentRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [thumbHeight, setThumbHeight] = useState(40);
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [startScrollTop, setStartScrollTop] = useState(0);
  const thumbRef = useRef(null);

  const toggleCircle = (item) => {
      setSelectedCircles((prev) => ({
          ...prev,
          [item]: !prev[item],
      }));
  };

  const handleSelect = (item) => {
      setSelectedItems(prev => {
          if (prev.includes(item)) {
              return prev.filter(i => i !== item);
          } else {
              return [...prev, item];
          }
      });
      
      if (typeof onChange === "function") {
          onChange(type, item);
      }
  };

  useEffect(() => {
      const content = contentRef.current;
      if (!content) return;

      const updateThumbHeight = () => {
          const { scrollHeight, clientHeight } = content;
          const visibleRatio = clientHeight / scrollHeight;
          setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
      };

      updateThumbHeight();
      window.addEventListener("resize", updateThumbHeight);
      return () => window.removeEventListener("resize", updateThumbHeight);
  }, [isOpen, items]);

  const handleScroll = () => {
      const content = contentRef.current;
      if (!content) return;

      const { scrollTop, scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      const scrollRatio = scrollTop / maxScrollTop;
      const trackHeight = content.clientHeight - thumbHeight;
      setScrollTop(scrollRatio * trackHeight);
  };

  const handleThumbMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();

      setIsDragging(true);
      setStartY(e.clientY);
      setStartScrollTop(contentRef.current.scrollTop);

      document.addEventListener("mousemove", handleThumbMouseMove);
      document.addEventListener("mouseup", handleThumbMouseUp);
      document.body.style.cursor = "grabbing";
  };

  const handleThumbMouseMove = (e) => {
      if (!isDragging) return;

      const deltaY = e.clientY - startY;
      const content = contentRef.current;
      const { scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      const trackHeight = clientHeight - thumbHeight;

      const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
      const newScrollTop = Math.min(
          Math.max(0, startScrollTop + scrollDelta),
          maxScrollTop
      );

      content.scrollTop = newScrollTop;
  };

  const handleThumbMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener("mousemove", handleThumbMouseMove);
      document.removeEventListener("mouseup", handleThumbMouseUp);
      document.body.style.cursor = "";
  };

  const handleTrackClick = (e) => {
      const content = contentRef.current;
      if (!content || e.target === thumbRef.current) return;

      const track = e.currentTarget;
      const trackRect = track.getBoundingClientRect();
      const clickPosition = e.clientY - trackRect.top;
      const thumbCenter = thumbHeight / 2;
      const scrollRatio =
          (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

      const { scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      content.scrollTop = scrollRatio * maxScrollTop;
  };

  const handleButtonScroll = (direction) => {
      if (contentRef.current) {
          contentRef.current.scrollBy({
              top: direction === 'up' ? -50 : 50,
              behavior: 'smooth'
          });
      }
  };

  return (
      <div className="flex flex-col w-full relative">
          <span className="text-[6px] md:text-[14px] md:mb-3 font-extrabold">
              {isProjectDropdown ? "" : label || "LANGUAGE"}
          </span>
          <div className="flex relative z-20 w-fit">
              <button
                  onClick={() => {
                      if (isProjectDropdown && selectedItems.includes("Funding")) {
                          window.location.href = "/funding";
                      } else {
                          setIsOpen(prev => !prev);
                      }
                  }}
                  className={`xl:w-[160px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[40px] bg-[#2E453D] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
              >
                  <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
                      {selectedItems.length > 0 ? selectedItems[0] : "-"}
                  </span>
              </button>

              <div
                  className="w-[15px] h-[15px] md:h-[40px] md:w-[40px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                  onClick={() => setIsOpen(prev => !prev)}
              >
                  <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                      alt="expand"
                      className="w-2 h-[10px] md:w-6 md:h-[24px]"
                  />
              </div>
          </div>

          <AnimatePresence>
              {isOpen && (
                  <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute top-full mt-1 left-0 z-[100] md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
                  >
                      <div className="w-full flex justify-end py-1">
                          <button 
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonScroll('up');
                              }}
                              className="p-1"
                          >
                              <img 
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png" 
                                  alt="Scroll up" 
                                  className="w-3 h-3"
                              />
                          </button>
                      </div>

                      <div className="custom-scroll-area">
                          <ul
                              className="custom-scroll-content"
                              ref={contentRef}
                              onScroll={handleScroll}
                          >
                          <li className="flex items-center justify-between px-2 py-1 mb-2">
                              <span className="text-[6px] md:text-[20px] font-semibold">
                                  {isProjectDropdown ? "Purpose" : label || "Language"}
                              </span>
                              <img
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750034880/Export_1_vurzim.png"
                                  alt="icon"
                                  className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      setIsOpen(false);
                                  }}
                              />
                          </li>
                              
                              {items && items.map((item, index) => (
                                  <li
                                      key={index}
                                      className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                                          selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                                      }`}
                                      onClick={() => handleSelect(item)}
                                  >
                                      <span className="text-black text-[4px] md:text-[18px]">
                                          {item}
                                      </span>
                                      <div
                                          className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${
                                              selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                                          }`}
                                      ></div>
                                  </li>
                              ))}
                          </ul>
                          <div className="custom-scroll-track" onClick={handleTrackClick}>
                              <div
                                  ref={thumbRef}
                                  className="custom-scroll-thumb"
                                  style={{
                                      height: `${thumbHeight}px`,
                                      top: `${scrollTop}px`,
                                      cursor: isDragging ? "grabbing" : "grab",
                                  }}
                                  onMouseDown={handleThumbMouseDown}
                              ></div>
                          </div>
                      </div>

                      <div className="w-full flex justify-end py-1">
                          <button 
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonScroll('down');
                              }}
                              className="p-1"
                          >
                              <img 
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png" 
                                  alt="Scroll down" 
                                  className="w-3 h-3"
                              />
                          </button>
                      </div>
                  </motion.div>
              )}
          </AnimatePresence>
          <p className="md:text-[10px] text-[4px] font-normal mt-1 text-black">
          Click to select individual  <br/>country reports
          </p>

          <style jsx>{`
              .custom-scroll-area {
                  position: relative;
                  max-height: 200px;
                  display: flex;
                  overflow: hidden;
              }

              .custom-scroll-content {
                  flex: 1;
                  overflow-y: scroll;
                  scrollbar-width: none;
                  -ms-overflow-style: none;
                  padding-right: 4px;
              }

              .custom-scroll-content::-webkit-scrollbar {
                  display: none;
              }

              .custom-scroll-track {
                  width: 14px;
                  background: #e7ebeb;
                  border-radius: 3px;
                  position: relative;
                  margin-left: 4px;
                  cursor: pointer;
              }

              .custom-scroll-thumb {
                  width: 100%;
                  background: #979797;
                  border-radius: 3px;
                  position: absolute;
                  right: 0;
                  transition: background 0.2s;
              }

              .custom-scroll-thumb:hover {
                  background: #444;
              }

              @media (max-width: 768px) {
                  .custom-scroll-track {
                      width: 4px;
                      margin-left: 2px;
                  }
                  .custom-scroll-area {
                      position: relative;
                      max-height: 150px;
                      display: flex;
                      overflow: hidden;
                      width: 100%;
                  }
              }
          `}</style>
      </div>
  );
};
const languageOptions = [
  "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", 
  "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", 
  "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"
];

const SMMEsOptions = [
  {
    heading: "Agriculture and Agribusiness",
    items: [
      { label: "Smallholder farms", value: "SMF" },
      { label: "Agro-processing", value: "AGP" },
      { label: "Agri-input suppliers", value: "AIP" },
      { label: "Horticulture businesses", value: "HCB" },
      { label: "Poultry", value: "POF" },
      { label: "Fish farms", value: "FIF" },
      { label: "Agri-tech startups", value: "ATC" }
    ]
  },
  {
    heading: "Manufacturing and Processing",
    items: [
      { label: "Textile and garment production", value: "TGP" },
      { label: "Furniture making and carpentry", value: "FPC" },
      { label: "Metal fabrication", value: "MEF" },
      { label: "Soap and detergent production", value: "SDP" },
      { label: "Food and beverage processing", value: "FBP" }
    ]
  },
  {
    heading: "Retail and Trade",
    items: [
      { label: "Small shops (dukas/spazas)", value: "SDS" },
      { label: "Market vendors", value: "MAV" },
      { label: "Wholesalers and distributors", value: "WHD" },
      { label: "Online retail platforms", value: "ORP" }
    ]
  },
  {
    heading: "Services",
    items: [
      { label: "Transport and logistics", value: "TRL" },
      { label: "Repair services", value: "RPS" },
      { label: "Beauty and personal care", value: "BPC" },
      { label: "Laundry and dry cleaning", value: "LDC" },
      { label: "Hospitality", value: "HOS" },
      { label: "Event planning and catering", value: "EPC" }
    ]
  },
  {
    heading: "Technology and Innovation (Tech SMEs)",
    items: [
      { label: "Fintech", value: "FIT" },
      { label: "Healthtech", value: "HET" },
      { label: "Edtech", value: "EDT" },
      { label: "Software and app development", value: "SAD" },
      { label: "E-commerce and logistics tech", value: "ECL" }
    ]
  },
  {
    heading: "Construction and Real Estate",
    items: [
      { label: "Small construction firms", value: "SCF" },
      { label: "Real estate agents and developers", value: "RAD" },
      { label: "Hardware and building material suppliers", value: "HBM" }
    ]
  },
  {
    heading: "Creative and Cultural Industries",
    items: [
      { label: "Art and crafts production", value: "ACP" },
      { label: "Music and film production", value: "MFP" },
      { label: "Fashion and design businesses", value: "FDB" },
      { label: "Photography and videography services", value: "PVS" }
    ]
  },
  {
    heading: "Health and Wellness",
    items: [
      { label: "Private clinics and pharmacies", value: "PCP" },
      { label: "Fitness centers and gyms", value: "FCG" },
      { label: "Traditional medicine practitioners", value: "TMP" },
      { label: "Health product distributors", value: "HPD" }
    ]
  },
  {
    heading: "Education and Training",
    items: [
      { label: "Private schools and daycares", value: "PSD" },
      { label: "Vocational training centers", value: "VTC" },
      { label: "Tutoring services", value: "TUS" },
      { label: "Edtech startups", value: "EDS" }
    ]
  }
]


const Dashboards = () => {
  const [dropdownSelections, setDropdownSelections] = useState({
    user_type: "English",
    user_purpose: "View reports",
    user_category: "All categories",
    communication_type: "CHAT"
  });

  const [savedMessages, setSavedMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState({
    text: `ALERT: Foot and Mouth Disease (FMD) Outbreak Detected
Location: [Insert region/county name]
Date Issued: [Insert date]

Dear Farmer,

An outbreak of Foot and Mouth Disease (FMD) has been reported in your area.
This highly contagious viral disease affects cattle, goats, sheep, pigs, and
other cloven-hoofed animals. Immediate action is required to protect your
livestock and limit the spread.`,
    image: null
  });
  const sendTestEmail = async () => {
    try {
      // Upload image if exists
      let imageUrl = null;
      if (selectedImage?.file) {
        const cloudinaryResponse = await uploadToCloudinary(selectedImage.file);
        imageUrl = cloudinaryResponse.secure_url;
      }
  
      // Format the message properly
      const formattedMessage = message
        .replace(/^Subject: .*\n/, '') // Remove subject line
        .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" style="color: #1a73e8; text-decoration: underline;">$1</a>') // Make links blue
        .replace(/\n/g, '<br>') // Convert newlines to HTML breaks
        .replace(/Dear Farmer,/g, '<strong>Dear Farmer,</strong>') // Bold the greeting
        .replace(/Thank you,/g, '<strong>Thank you,</strong>'); // Bold the closing
  
      const response = await emailjs.send(
        emailjsConfig.serviceId,
        emailjsConfig.templateId,
        {
          to_email: "wajeehabaig2@gmail.com", // CHANGE THIS
          message: formattedMessage,
          subject: "Complete Your Farmnet Registration Today", // Use the subject from the message
          image_url: imageUrl || ''
        },
        emailjsConfig.userId
      );
      
      console.log('EmailJS Response:', response);
      alert('Test email sent! Check your inbox and spam folder.');
    } catch (error) {
      console.error('EmailJS Error:', error);
      alert(`Failed: ${error.text || error.message}`);
    }
  };
  
  
  // Call this function from a button click or useEffect to test
  const [reportSelections, setReportSelections] = useState({
    COUNTRY: "-",
    REGION: "-",
    DISTRICT: "-",
    MUNICIPALITY: "-",
    SMMEs: "-",
    "VALUE CHAIN": "-",
    PROJECT: "-",
    "USER TYPE": "-",
    individualContacts: []
  });

  const [message, setMessage] = useState(
    `Subject: Complete Your Farmnet Registration Today
    
    👉 Dear Farmer,
    
    Have you completed your registration on the Farmnet platform?
    
    Completing your profile is important. It allows offtake partners to see what you produce and gives you a real opportunity to connect with buyers and supply your produce.
    
    Make sure your farm is visible and ready for market opportunities.
    
    Complete your registration now: https://www.farmnet.africa/Register
    
    Let your farm be seen. Let your produce find buyers.
    
    👉 Thank you,
    
    The Farmnet Team`
    );

  const [isEditing, setIsEditing] = useState(false);
  const [showMessage, setShowMessage] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null); // Initialize as null
  const [isSending, setIsSending] = useState(false);
  
  const fileInputRef = useRef(null);
  const messageRef = useRef(null);

  const handleAddImageClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    if (!file.type.match('image.*')) {
      alert('Please select an image file');
      return;
    }
  
    setSelectedImage({
      file: file,
      preview: URL.createObjectURL(file)
    });
  };
  const handleDeleteImage = useCallback((e) => {
    e.stopPropagation();
    updateSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }, []);

  const validateContact = (input) => {
    input = input.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?[\d\s-]{8,}$/;
    
    if (emailRegex.test(input)) {
      return { valid: true, type: 'email', normalized: input.toLowerCase() };
    }
    
    if (phoneRegex.test(input)) {
      const normalized = input.replace(/[^\d+]/g, '');
      return { valid: true, type: 'phone', normalized };
    }
    
    return { valid: false, type: null };
  };

  const handleDropdownChange = (type, value) => {
    setDropdownSelections(prev => ({
      ...prev,
      [type]: value
    }));
  };

  const handleReportDropdownChange = (type, value) => {
    setReportSelections(prev => {
      const newSelections = {
        ...prev,
        [type]: value
      };
      
      if (type === 'COUNTRY') {
        newSelections.REGION = "-";
        newSelections.DISTRICT = "-";
        newSelections.MUNICIPALITY = "-";
      }
      
      return newSelections;
    });
  };

  const handleEditClick = () => {
    setIsEditing(true);
    setTimeout(() => {
      if (messageRef.current) {
        messageRef.current.focus();
        // Set cursor to end of text
        messageRef.current.selectionStart = messageRef.current.value.length;
        messageRef.current.selectionEnd = messageRef.current.value.length;
      }
    }, 0);
  };
  
 
  const updateMessage = (newText) => {
    setMessage(newText);
    setCurrentMessage(prev => ({ ...prev, text: newText }));
  };

  const updateSelectedImage = (image) => {
    setSelectedImage(image);
    setCurrentMessage(prev => ({ ...prev, image }));
  };

  const handleSaveClick = async () => {
    setIsEditing(false);
    
    try {
      let imageUrl = null;
      
      if (selectedImage?.file) {
        try {
          const cloudinaryResponse = await uploadToCloudinary(selectedImage.file);
          imageUrl = cloudinaryResponse.secure_url;
        } catch (uploadError) {
          console.error("Cloudinary upload failed:", uploadError);
          throw new Error("Failed to upload image. Please try again.");
        }
      }
  
      const messageData = {
        text: message,
        contacts: [...(reportSelections.individualContacts || [])],
        imageUrl: imageUrl || null,
        timestamp: new Date().toISOString(),
        status: "draft"
      };
  
      const docRef = await addDoc(collection(db, "messages"), messageData);
      
      setSavedMessages(prev => [...prev, {
        id: docRef.id,
        ...messageData
      }]);
      
      alert("Message saved successfully!");
    } catch (error) {
      console.error("Error saving message:", error);
      alert(error.message || "Failed to save message.");
    }
  };
  const handleDeleteMessage = () => {
    setShowMessage(false);
    setTimeout(() => {
      setMessage("");
      setShowMessage(true);
    }, 500);
  };
  const uploadImageToFirebase = async (imageFile, maxRetries = 3) => {
    if (!imageFile) return null;
  
    const storageRef = ref(storage, `messages/${Date.now()}-${Math.random().toString(36).substring(2, 8)}`);
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const uploadTask = uploadBytesResumable(storageRef, imageFile);
        
        await new Promise((resolve, reject) => {
          uploadTask.on('state_changed',
            null,
            (error) => reject(error),
            () => resolve()
          );
        });
        
        return await getDownloadURL(uploadTask.snapshot.ref);
      } catch (error) {
        console.error(`Upload attempt ${attempt} failed:`, error);
        if (attempt === maxRetries) throw error;
        await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
      }
    }
  };
  
  const sendEmailsIndividually = async (emails, message, imageUrl) => {
    const successfulSends = [];
    const failedSends = [];
  
    for (const email of emails) {
      try {
        const response = await emailjs.send(
          emailjsConfig.serviceId,
          emailjsConfig.templateId,
          {
            to_email: email,
            message: message.replace(/\n/g, '<br>'),
            image_url: imageUrl || '',
            subject: `FarmNet Alert - ${new Date().toLocaleDateString()}`
          },
          emailjsConfig.userId
        );
  
        successfulSends.push(email);
        console.log(`Email sent to ${email}`, response);
  
        // Throttle requests to avoid rate limiting
        await new Promise(resolve => setTimeout(resolve, 500));
      } catch (error) {
        failedSends.push({ email, error });
        console.error(`Failed to send to ${email}:`, error);
      }
    }
  
    return { successfulSends, failedSends };
  };
  const sendEmailsInBatches = async (emails, message) => {
    const BATCH_SIZE = 10; // Small batches to avoid rate limits
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    
    for (let i = 0; i < emails.length; i += BATCH_SIZE) {
      const batch = emails.slice(i, i + BATCH_SIZE);
      
      await Promise.all(batch.map(email => 
        emailjs.send(
          emailjsConfig.serviceId,
          emailjsConfig.templateId,
          {
            to_email: email,
            message: message,
            subject: "FarmNet Update"
          },
          emailjsConfig.userId
        ).catch(e => console.error(`Failed to send to ${email}:`, e))
      ));
      
      await delay(2000); // 2 second delay between batches
    }
  };
  const handleSendClick = async () => {
    if (!message.trim()) {
      alert("Please enter a message to send");
      return;
    }
  
    setIsSending(true);
    setShowProgressModal(true);
    setSendProgress({
      total: 0,
      sent: 0,
      failed: 0,
      isCancelled: false
    });
  
    try {
      // 1. Upload image if exists
      let imageUrl = null;
      if (selectedImage?.file) {
        const cloudinaryResponse = await uploadToCloudinary(selectedImage.file);
        imageUrl = cloudinaryResponse.secure_url;
      }
  
      // 2. Fetch all users with better error handling
      const registrationsRef = collection(db, "registrations");
      const snapshot = await getDocs(registrationsRef);
      
      const recipients = {
        emails: [],
        successfulEmails: [],
        failedEmails: [],
        errors: []
      };
  
      // Validate and prepare recipient list
      snapshot.forEach(doc => {
        const data = doc.data();
        if (data.personalInfo?.email) {
          const email = data.personalInfo.email.trim().toLowerCase();
          if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            recipients.emails.push({
              email,
              userId: doc.id,
              status: 'pending'
            });
          } else {
            recipients.errors.push(`Invalid email format: ${email}`);
          }
        }
      });
  
      setSendProgress(prev => ({ ...prev, total: recipients.emails.length }));
  
      // 3. Format the message
      const formattedMessage = message
        .replace(/^Subject: .*\n/, '')
        .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" style="color: #1a73e8; text-decoration: underline;">$1</a>')
        .replace(/\n/g, '<br>')
        .replace(/Dear Farmer,/g, '<strong>Dear Farmer,</strong>')
        .replace(/Thank you,/g, '<strong>Thank you,</strong>');
  
      // 3. Send emails with proper rate limiting
      const BATCH_SIZE = 5;
      const DELAY_BETWEEN_BATCHES = 3000;
      
      for (let i = 0; i < recipients.emails.length; i += BATCH_SIZE) {
        // Check if user cancelled the operation
        if (sendProgress.isCancelled) {
          break;
        }
  
        const batch = recipients.emails.slice(i, i + BATCH_SIZE);
        
        // Process current batch with individual delays
        for (const recipient of batch) {
          try {
            if (sendProgress.isCancelled) {
              recipient.status = 'cancelled';
              continue;
            }
  
            const response = await emailjs.send(
              emailjsConfig.serviceId,
              emailjsConfig.templateId,
              {
                to_email: recipient.email,
                message: formattedMessage,
                image_url: imageUrl || '',
                subject: message.match(/^Subject: (.*)$/m)?.[1] || "FarmNet Alert"
              },
              emailjsConfig.userId
            );
            console.log(`Success: ${recipient.email}`, response);
            recipient.status = 'sent';
            recipient.response = response;
            recipients.successfulEmails.push(recipient.email);
            
            // Update progress
            setSendProgress(prev => ({
              ...prev,
              sent: prev.sent + 1
            }));
  
            // Add delay between individual emails
            await new Promise(resolve => setTimeout(resolve, 500));
            
          } catch (error) {
            console.error(`Failed: ${recipient.email}`, error);
            recipient.status = 'failed';
            recipient.error = error;
            recipients.failedEmails.push(recipient.email);
            recipients.errors.push(`Failed to send to ${recipient.email}: ${error.message}`);
            
            // Update progress
            setSendProgress(prev => ({
              ...prev,
              failed: prev.failed + 1
            }));
  
            // If we hit rate limit, wait longer before continuing
            if (error.status === 429) {
              await new Promise(resolve => setTimeout(resolve, 10000));
            }
          }
        }
        
        // Delay between batches if not last batch and not cancelled
        if (i + BATCH_SIZE < recipients.emails.length && !sendProgress.isCancelled) {
          await new Promise(resolve => setTimeout(resolve, DELAY_BETWEEN_BATCHES));
        }
      }
  
      // 4. Save detailed message record only if not cancelled
      if (!sendProgress.isCancelled) {
        await addDoc(collection(db, "messages"), {
          text: message,
          recipients: recipients,
          imageUrl: imageUrl,
          timestamp: new Date().toISOString(),
          status: "sent",
          type: dropdownSelections.communication_type,
          stats: {
            total: recipients.emails.length,
            successful: recipients.successfulEmails.length,
            failed: recipients.failedEmails.length
          }
        });
      }
  
    } catch (error) {
      console.error("Overall sending error:", error);
    } finally {
      setIsSending(false);
      setShowProgressModal(false);
      
      if (!sendProgress.isCancelled) {
        alert(`Email sending completed:
        Total: ${sendProgress.total}
        Successful: ${sendProgress.sent}
        Failed: ${sendProgress.failed}`);
      } else {
        alert("Email sending was cancelled");
      }
    }
  };
  
  const handleCancelSend = () => {
    setSendProgress(prev => ({ ...prev, isCancelled: true }));
    setShowProgressModal(false);
    setIsSending(false);
  };
  const handleAddContact = () => {
    const input = prompt("Enter email or phone number:");
    if (input) {
      const { valid, type, normalized } = validateContact(input);
      
      if (!valid) {
        alert("Please enter a valid email or phone number (international format)");
        return;
      }
      
      setReportSelections(prev => ({
        ...prev,
        individualContacts: [...(prev.individualContacts || []), normalized || input]
      }));
    }
  };
  console.log("Sending message:", message);
const [sendProgress, setSendProgress] = useState({
  total: 0,
  sent: 0,
  failed: 0,
  isCancelled: false
});
const [showContactInput, setShowContactInput] = useState({
  phone: false,
  email: false
});
const [showProgressModal, setShowProgressModal] = useState(false);
const [leftValue, setLeftValue] = useState('XXXXXXXXXX');
const [rightValue, setRightValue] = useState('XXXXXXXXXX');
const [isEditing1, setIsEditing1] = useState({
  left: false,
  right: false
});
const [tempValues, setTempValues] = useState({
  left: leftValue,
  right: rightValue
});

const handleSave = (side) => {
  const newValues = {
    left: side === 'left' ? tempValues.left : leftValue,
    right: side === 'right' ? tempValues.right : rightValue
  };

  if (side === 'left') {
    setLeftValue(tempValues.left);
  } else {
    setRightValue(tempValues.right);
  }
  
  setIsEditing1({ ...isEditing1, [side]: false });
  
  // Add the current values to savedBoxes
  setSavedBoxes(prev => [...prev, {
    left: newValues.left,
    right: newValues.right,
    id: Date.now() // Use timestamp as unique ID
  }]);
};
const SavedBoxesList = ({ boxes, onDelete }) => {
  return (
    <div className="mt-2 space-y-2">
      {boxes.map((box) => (
        <div key={box.id} className="flex">
          {/* Left Box */}
          <div
            className="flex items-center justify-between w-1/2 h-[45px] border-b border-black pl-3 pr-2"
            style={{ borderLeft: '5px solid #CCD2D8', backgroundColor: '#D3D8DE' }}
          >
            <div className="flex flex-col justify-center">
              <span className="text-xs font-bold leading-tight">{box.left}</span>
            </div>
          </div>

          {/* Right Box */}
          <div
            className="flex items-center justify-between w-1/2 h-[45px] border-b border-black pl-3 pr-2"
            style={{ backgroundColor: '#E7EBEB' }}
          >
            <div className="flex flex-col justify-center">
              <span className="text-xs font-bold leading-tight">{box.right}</span>
            </div>
            <button onClick={() => onDelete(box.id)}>
              <img
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Trash_qyp2jm.png"
                alt="Delete"
                className="w-4 h-4 cursor-pointer"
              />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
const handleDeleteBox = (id) => {
  setSavedBoxes(prev => prev.filter(box => box.id !== id));
};
const handleEdit = (side) => {
  setTempValues({
    left: leftValue,
    right: rightValue
  });
  setIsEditing1({ ...isEditing1, [side]: true });
};

const handleChange = (e, side) => {
  setTempValues({ ...tempValues, [side]: e.target.value });
};

const [savedBoxes, setSavedBoxes] = useState([]);
  return (
    <div className="bg-[#FAFBFB]">
      <div className="md:pt-4 pt-1">
        <Header/>
        <div className="flex flex-col md:min-h-screen">
          <div className="flex flex-grow">
            <div>
              <AdminSideBar />
            </div>
            <div className="w-full overflow-x-hidden">
              <div className="flex justify-between items-center px-4">
                <h2 className="md:text-[30px] text-[12px] capitalize text-[#152C24] font-bold">
                  COMMUNICATION
                </h2>
                <div className="flex items-center md:gap-4 gap-2">
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1752600948/image_1854_enk1t0.png"
                    alt="bell"
                    className="md:w-[51px] md:h-[51px] w-[25px] h-[25px]"
                  />
                  <div className="md:w-[500px] md:mb-4 md:mt-6 mb-2">
                    <div className="relative">
                      <input
                        placeholder="Search"
                        type="text"
                        className="w-full md:h-[61px] h-[30px] text-[#979797] text-[10px] md:text-[16px] font-semibold md:p-3 pr-10 p-1 md:px-6 px-3 border border-[#C4C4C4] md:rounded-md rounded-full focus:outline-none focus:ring-2 focus:ring-green-600"
                      />
                      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
                        alt="Search Icon"
                        className="w-[18px] h-[15px] md:h-[24px] md:w-[24px] absolute right-5 top-1/2 transform -translate-y-1/2"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center px-4">
                <div>
                  <Dropdown
                    label="COUNTRY"
                    items={languageOptions}
                    type="FACILITATOR"
                    isProjectDropdown={false}
                    onChange={(type, value) => handleDropdownChange('user_type', value)}
                    className="border-r-0 rounded-r-none"
                  />
                </div>
                
                <div className="flex items-center">
                  <Dropdown1
                    label="TYPE OF COMMUNICATION"
                    items={["CHAT", "Emails", "SMS", "WhatsApp"]}
                    type="COMMUNICATION_TYPE"
                    isProjectDropdown={false}
                    onChange={(type, value) => handleDropdownChange('communication_type', value)}
                    className="border-r-0 rounded-r-none"
                  />
                </div>
              </div>
              <div>
                <ReportDropdown2
                  values={reportSelections}
                  onChange={handleReportDropdownChange}
                  smmesOptions={SMMEsOptions}
                />
              </div>
              
              <div className="flex flex-col space-y-6 p-1 font-sans">
                <div className="flex flex-col md:flex-row justify-between gap-1">
                  <div className="w-full md:w-[50%]">
                    <p className="text-[12px] font-semibold uppercase mb-1">BULK COMMUNICATION</p>
                    <div className="w-full h-[46px] bg-[#E7EBEB] rounded-[5px] p-2 flex flex-col justify-center">
                      <span className="text-[12px]">
                        {reportSelections.REGION === "-" ? "CASTOR" : 
                         typeof reportSelections.REGION === 'object' ? 
                         reportSelections.REGION.name : 
                         reportSelections.REGION}
                      </span>
                    </div>
                    <span className="text-[12px] text-black">
                      Selection appears here eg Gauteng, Johannesburg, Castor or association
                    </span>
                  </div>
                  <div className="w-full md:w-[40%]">
  <p className="text-[12px] font-semibold uppercase mb-1">INDIVIDUAL COMMUNICATION</p>
  <div className="flex flex-col">
    {/* Boxes Row */}
    <div className="flex">
      {/* Left Box */}
      <div
        className="flex items-center justify-between w-1/2 h-[45px] border-b border-black pl-3 pr-2"
        style={{ borderLeft: '5px solid #CCD2D8', backgroundColor: '#D3D8DE' }}
      >
        {isEditing1.left ? (
          <input
            type="text"
            value={tempValues.left}
            onChange={(e) => handleChange(e, 'left')}
            className="w-full bg-transparent outline-none text-xs font-bold"
            autoFocus
            onBlur={() => handleSave('left')}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSave('left');
            }}
          />
        ) : (
          <div 
            className="flex flex-col justify-center w-full"
            onClick={() => handleEdit('left')}
          >
            <span className="text-xs font-bold leading-tight">
              {leftValue}
            </span>
          </div>
        )}
        {isEditing1.left ? (
          <button onClick={() => handleSave('left')}>
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Import_duotone_line_f6ym1x.png"
              alt="save"
              className="w-4 h-4 cursor-pointer"
            />
          </button>
        ) : (
          <button onClick={() => handleEdit('left')}>
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Import_duotone_line_f6ym1x.png"
              alt="edit"
              className="w-4 h-4 cursor-pointer"
            />
          </button>
        )}
      </div>

      {/* Right Box */}
      <div
        className="flex items-center justify-between w-1/2 h-[45px] border-b border-black pl-3 pr-2"
        style={{ backgroundColor: '#E7EBEB' }}
      >
        {isEditing1.right ? (
          <input
            type="text"
            value={tempValues.right}
            onChange={(e) => handleChange(e, 'right')}
            className="w-full bg-transparent outline-none text-xs font-bold"
            autoFocus
            onBlur={() => handleSave('right')}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSave('right');
            }}
          />
        ) : (
          <div 
            className="flex flex-col justify-center w-full"
            onClick={() => handleEdit('right')}
          >
            <span className="text-xs font-bold leading-tight">
              {rightValue}
            </span>
          </div>
        )}
        {isEditing1.right ? (
          <button onClick={() => handleSave('right')}>
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Import_duotone_line_f6ym1x.png"
              alt="save"
              className="w-4 h-4 cursor-pointer"
            />
          </button>
        ) : (
          <button onClick={() => handleEdit('right')}>
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Import_duotone_line_f6ym1x.png"
              alt="edit"
              className="w-4 h-4 cursor-pointer"
            />
          </button>
        )}
      </div>
    </div>

    {/* Text Below Boxes */}
    <div className="flex">
      <div className="w-1/2 pl-3">
        <span className="text-xs leading-tight">Type phone number</span>
      </div>
      <div className="w-1/2 pl-3">
        <span className="text-xs leading-tight">Type email</span>
      </div>
    </div>

    {/* Saved Boxes List */}
    {savedBoxes.length > 0 && (
      <div className="mt-0">
        <SavedBoxesList boxes={savedBoxes} onDelete={handleDeleteBox} />
      </div>
    )}
  </div>

  {/* Existing individual contacts list */}
  {(reportSelections.individualContacts || []).map((contact, index) => (
    <div 
      key={index} 
      className="w-full h-[46px] bg-[#F3F5F5] rounded-[5px] px-2 flex items-center justify-between mb-2 text-[12px]"
    >
      {contact}
      <img
        src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Trash_qyp2jm.png"
        alt="Delete"
        className="w-4 h-4 cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          setReportSelections(prev => ({
            ...prev,
            individualContacts: prev.individualContacts.filter((_, i) => i !== index)
          }));
        }}
      />
    </div>
  ))}
</div>
                </div>

                <div className="flex flex-col md:flex-row justify-between">
                  <div className="w-full md:w-[60%]">
                    <h2 className="text-[20px] font-bold mb-2">Communication</h2>
                    
                    <AnimatePresence>
  {showMessage && (
    <motion.div
      key="message-box"
      initial={{ opacity: 1, rotateX: 0 }}
      animate={{ opacity: 1, rotateX: 0 }}
      exit={{ opacity: 0, rotateX: 90 }}
      transition={{ duration: 0.5 }}
      className="w-full h-[300px] bg-[#F3F5F5] rounded-[5px] p-4 relative overflow-hidden"
    >
      <div className="flex justify-between items-center mb-1">
        <span className="text-[#979797] text-[10px]">
          {isEditing ? "Editing message..." : "Type chat message here...."}
        </span>
        {!isEditing ? (
          <motion.div 
            className="flex items-center gap-3 cursor-pointer"
            onClick={handleEditClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="text-[10px] font-bold text-black">Edit</span>
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Edit_fill_wcehpm.png"
              alt="Edit"
              className="w-3 h-3"
            />
          </motion.div>
        ) : (
          <motion.div 
            className="flex items-center gap-3 cursor-pointer"
            onClick={handleSaveClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="text-[10px] font-bold text-black">Save</span>
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Import_b3c5cs.png"
              alt="Save"
              className="w-3 h-3"
            />
          </motion.div>
        )}
      </div>

      {isEditing ? (
        <textarea
          ref={messageRef}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full h-[220px] bg-transparent text-[12px] font-medium focus:outline-none resize-none p-1 overflow-auto"
          style={{ 
            fontFamily: 'sans-serif',
            lineHeight: '1.3'
          }}
        />
      ) : (
        <div className="text-[12px] font-medium whitespace-pre-wrap mt-2 h-[220px] overflow-y-auto">
          {message.split('\n').map((line, i) => (
            <div 
              key={i} 
              className={`flex ${line.startsWith('👉') ? 'items-baseline' : ''}`}
              style={{ marginBottom: '4px' }}
            >
              {line.startsWith('👉') ? (
                <>
                  <span className="mr-1" style={{ fontSize: '12px' }}>👉</span>
                  <span className="font-bold">{line.replace('👉', '').trim()}</span>
                </>
              ) : line.trim() === '' ? (
                <br />
              ) : (
                <span>{line}</span>
              )}
            </div>
          ))}
        </div>
      )}

      <motion.div 
        className="flex items-center gap-3 cursor-pointer absolute bottom-4 right-4"
        onClick={handleDeleteMessage}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <span className="text-[10px] font-bold text-black">Delete</span>
        <img
          src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Trash_qyp2jm.png"
          alt="Delete"
          className="w-5 h-5"
        />
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>
                  </div>
 
                  <div className="w-full md:w-[40%] relative"> 
  <h2 className="text-[20px] font-bold mb-2 text-white">Image Preview</h2>
  <div className="bg-[#E7EBEB] rounded-[5px] w-full h-[300px] p-4 flex flex-col justify-between relative overflow-hidden">
    {selectedImage?.preview ? (
      <>
        <div className="absolute inset-0 flex items-center justify-center">
          <img 
            src={selectedImage.preview} 
            alt="Uploaded content" 
            className="max-w-full max-h-full object-contain"
          />
        </div>
        <motion.div 
          className="flex items-center gap-3 cursor-pointer absolute bottom-4 right-4 z-10" 
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => setSelectedImage(null)}
        >
          <span className="text-[12px] font-bold text-black">Delete</span>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Trash_qyp2jm.png"
            alt="Delete"
            className="w-6 h-6"
          />
        </motion.div>
      </>
    ) : (
      <>
        <div className="flex justify-end items-center z-10">
          <span className="text-[12px] font-bold mr-2">Add image</span>
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={handleAddImageClick}
            className="cursor-pointer"
          >
            <img
              src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Add_square_duotone_lat1qk.png"
              alt="Add"
              className="w-[45px] h-[45px]"
            />
          </motion.div>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleImageUpload}
            accept="image/*"
            className="hidden"
          />
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-[#979797] text-[12px]">No image selected</span>
        </div>
      </>
    )}
  </div>
</div>
                </div>
              </div>

              <div className="flex justify-between items-end p-1 pb-1">
                <motion.div 
                  className="flex items-center gap-4 cursor-pointer"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleSaveClick}
                >
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Import_b3c5cs.png"
                    alt="Save"
                    className="w-4 h-4"
                  />
                  <span className="text-[16px] font-bold">Save</span>
                </motion.div>
                <motion.div 
  className="flex items-center gap-4 cursor-pointer"
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
  style={{ opacity: isSending ? 0.7 : 1 }}
  onClick={!isSending ? handleSendClick : undefined}
>
  <img
    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Send_light_mab0ho.png"
    alt="Send"
    className="w-5 h-5"
  />
  <span className="text-[16px] font-bold">
    {isSending ? "Sending..." : "Send"}
  </span>
</motion.div>
{/* <motion.div 
  className="flex items-center gap-4 cursor-pointer bg-blue-500 text-white px-4 py-2 rounded-md"
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
  onClick={sendTestEmail}
>
  <img
    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1753371503/Send_light_mab0ho.png"
    alt="Send Test"
    className="w-5 h-5"
  />
  <span className="text-[16px] font-bold">Send Test Email</span>
</motion.div> */}
              </div>
            </div>
          </div>

          <div className="mt-auto">
            <Footer />
          </div>
        </div>
      </div>
      {showProgressModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full"
    >
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold">Sending Emails</h3>
        <div className="w-8 h-8 flex items-center justify-center">
          {!sendProgress.isCancelled && (
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900"></div>
          )}
        </div>
      </div>
      
      <div className="mb-4">
        <div className="flex justify-between text-sm mb-1">
          <span>Progress:</span>
          <span>{sendProgress.sent + sendProgress.failed} of {sendProgress.total}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div 
            className="bg-green-600 h-2.5 rounded-full" 
            style={{ width: `${((sendProgress.sent + sendProgress.failed) / sendProgress.total) * 100}%` }}
          ></div>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="bg-green-50 p-3 rounded">
          <div className="text-green-800 font-bold text-xl">{sendProgress.sent}</div>
          <div className="text-green-600 text-sm">Successful</div>
        </div>
        <div className="bg-red-50 p-3 rounded">
          <div className="text-red-800 font-bold text-xl">{sendProgress.failed}</div>
          <div className="text-red-600 text-sm">Failed</div>
        </div>
      </div>
      
      <p className="text-gray-600 text-sm mb-4">
        {sendProgress.isCancelled ? 
          "Cancelling... Please wait" : 
          `Sending emails... ${sendProgress.sent} people have received it so far`}
      </p>
      
      {!sendProgress.isCancelled && (
        <button
          onClick={handleCancelSend}
          className="w-full bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded transition"
        >
          Cancel Sending
        </button>
      )}
    </motion.div>
  </div>
)}
    </div>
  );
};

export default Dashboards;
